module.exports = __webpack_public_path__ + "static/media/ΛΑΓΟΣ ΧΕΛΩΝΑ (ΑΝΓ).b4800953.mp4";